
export const CODE_VERIFIER_KEY = 'pkce_code_verifier';
export const STATE_KEY = 'pkce_state';